import React, { FC, useCallback } from 'react';
import { ButtonBase, ButtonBaseProps } from '@material-ui/core';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_THEME_COLOR, FETCH_ASSETS_URL } from 'appenv';
import CircularLoadingIndicator from 'components/indicators/CircularLoadingIndicator';
import { selectTotalUnreadCount, isTwilioConnected, setChatInterface } from 'models/twilio';
import ChatBadge from '../styled/ChatBadge';

const ChatroomIcon = `${FETCH_ASSETS_URL}/assets/chatroomWhite.svg`;

const MobileChatButtonBase = styled(ButtonBase)<{ $color: string }>`
  background: ${({ $color }) => $color};
  padding: 16px;
  border-radius: 100%;
  overflow: hidden;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);
`;

const StyledCircularLoadingIndicator = React.memo(styled(CircularLoadingIndicator)`
  margin: 0;
`);

const MobileChatButton: FC<ButtonBaseProps> = ({ ...buttonBaseProps }) => {
  const dispatch = useDispatch();

  const { themeColor = DEFAULT_THEME_COLOR } = useSelector((state) => state.eventConfigs, () => true);
  const totalUnreadCount = useSelector(selectTotalUnreadCount);
  const twilioConnected = useSelector(isTwilioConnected);

  const displayChat = useCallback(() => {
    if (!twilioConnected) return;
    dispatch(setChatInterface(true));
  }, [dispatch, twilioConnected]);

  return (
    <ChatBadge unreadCount={totalUnreadCount}>
      <MobileChatButtonBase $color={themeColor} {...buttonBaseProps} onClick={displayChat} disabled={!twilioConnected}>
        {twilioConnected ? (
          <img src={ChatroomIcon} alt="Chatroom Icon" />
        ) : (
          <StyledCircularLoadingIndicator color="white" size={24} />
        )}
      </MobileChatButtonBase>
    </ChatBadge>
  );
};

export default MobileChatButton;
